const MAPA_ACENTOS: Record<string, string> = {
  á: 'a', à: 'a', ä: 'a', â: 'a',
  é: 'e', è: 'e', ë: 'e', ê: 'e',
  í: 'i', ì: 'i', ï: 'i', î: 'i',
  ó: 'o', ò: 'o', ö: 'o', ô: 'o',
  ú: 'u', ù: 'u', ü: 'u', û: 'u',
  ñ: 'n',
};

/** Quita tildes/diacriticos y pasa a minusculas, para comparar texto sin importar acentos. */
export function normalize(value: string): string {
  return value
    .toLowerCase()
    .split('')
    .map((char) => MAPA_ACENTOS[char] ?? char)
    .join('');
}

/** Genera un id valido de HTML a partir de un texto (usado para los anchors de categoria). */
export function slugify(value: string): string {
  return normalize(value).replace(/[^a-z0-9]+/g, '-');
}

export function categoryAnchorId(category: string): string {
  return `help-group-${slugify(category)}`;
}
